import React from "react";

// ============================================================
// StatusRing — Phase 1 glossy ring wrapper.
// ============================================================
// Applies the correct `.ring-*` class from tokens.css to a
// wrapper <div> so any child (Avatar, <img>, decorative
// circle, etc.) inherits the ring border, glossy `::after`
// overlay, and dark-mode variant automatically.
//
// Viewer-role gate:
//   • superadmin / super_admin / limited_admin / pastor
//     → ring is rendered.
//   • team_member / undefined / any other role
//     → children render as-is, no border, no gloss.
//
// This mirrors the Avatar component's contract so the two
// stay consistent everywhere they're used.
// ============================================================

const RING_CLASS = {
  "Active":       "ring-active",
  "New Member":   "ring-new",
  "Visitor":      "ring-visitor",
  "Guest":        "ring-guest",
  "Inactive":     "ring-inactive",
  "Left Church":  "ring-left",
  "Deceased":     "ring-deceased",
};

const PRIVILEGED = new Set(["superadmin", "super_admin", "limited_admin", "pastor"]);

export function StatusRing({
  status,
  viewerRole,
  className = "",
  style = {},
  children,
  ...rest
}) {
  const show = !!status && RING_CLASS[status] && PRIVILEGED.has(viewerRole);
  const ringClass = show ? RING_CLASS[status] : "";
  const combined = [ringClass, className].filter(Boolean).join(" ");
  return (
    <div
      className={combined}
      style={{
        position: "relative",
        display: "inline-flex",
        borderRadius: "50%",
        ...style,
      }}
      data-status={status || undefined}
      data-ring={show ? "on" : undefined}
      {...rest}
    >
      {children}
    </div>
  );
}

export default StatusRing;
